import { Image } from "@crystallize/reactjs-components";
import { TileViewComponentProps } from "../../../lib/grid-tile/types";
import { LinkRenderer } from "../../../lib/grid-tile/linkRenderer";
import { Video } from "@crystallize/reactjs-components";
import Link from "next/link";
import { RichTextRenderer } from "~/ui/components/rich-text-renderer";

export const Banner: React.FC<TileViewComponentProps> = ({ tile }) => {
  const { title, description, ctas, isFullWidth, content, styling } = tile;
  const { images, videos } = content;
  const { font, button, filter } = styling || {};

  return (
    <div
      className={`flex lg:flex-row flex-col w-full mx-auto ${
        isFullWidth
          ? "px-0 max-w-[1600px] w-full items-center pt-10 lg:py-0 "
          : "pl-10 pt-20"
      }`}
    >
      <div
        className={`${
          !images?.length ? "py-40" : isFullWidth ? "lg:w-1/2" : "lg:w-2/5"
        } items-center pr-5 pl-5 md:pr-0 flex-column relative z-10 py-4 lg:px-10 `}
      >
        {title && (
          <h1
            className={`text-3xl md:text-4xl lg:text-5xl leading-[1em] font-bold mb-5`}
            style={{ fontSize: font ? font.size : "2rem" }}
          >
            {title}
          </h1>
        )}
        {description && (
          <div className={`mt-2 mb-5 max-w-[400px] leading-[1.6em]`}>
            <RichTextRenderer json={description} />
          </div>
        )}
        {ctas &&
          ctas.map((cta) => (
            <Link href={cta.link} tabIndex={-1} key={cta.link}>
              <button
                className="px-8 py-3 font-medium mr-2 mb-8"
                key={cta.text}
                style={{
                  color: button?.color ? button.color : "#fff",
                  backgroundColor: button?.["background color"]
                    ? button["background color"]
                    : "#000",
                  fontSize: button?.["font size"]
                    ? button["font size"]
                    : "1rem",
                }}
              >
                {cta.link ? cta.text : cta.text}
              </button>
            </Link>
          ))}
      </div>
      {images && images.length > 0 && (
        <div className="md:w-8/12 w-full pt-10 img-container img-cover md:py-0 hidden lg:block">
          <Image
            {...images[0]}
            sizes="(max-width: 500px) 300px, 700px"
            loading="lazy"
            className="max-w-none w-full"
            style={{
              filter: filter?.grayscale
                ? `grayscale(${filter.grayscale}%)`
                : "unset",
            }}
          />
        </div>
      )}
      {videos && videos.length > 0 && (
        <div className="md:w-8/12 w-full img-container img-contain md:py-0">
          <Video
            {...videos[0]}
            thumbnailProps={{ sizes: "(max-width: 700px) 90vw, 700px" }}
          />
        </div>
      )}
    </div>
  );
};
